module.exports = __webpack_public_path__ + "img/call-chat--mobile.54c557d.jpg";